import * as React from 'react'
import {HashRouter as Router, Route, Switch} from 'react-router-dom'
import {observer} from 'mobx-react'
import {globalStore} from "../../src/store/GlobalStore";
import {getRouteMap} from "../../src/utils/react/routerUtil";
import ServerError from "../../src/components/ServerError";

// 静的インポート（Parcel のコード分割問題を回避）
import Login from './../views/Login';
import Member from './../views/Member';
import InformationDetail from './../views/Information/detail';
import UseFastlane from './../views/UseFastlane';
import PermitError from './../views/PermitError';
import DisplayPermit from './../views/DisplayPermit';
import MyPage from './../views/MyPage';
import PasswordReset from './../views/PasswordReset';
import PasswordResetExec from './../views/PasswordResetExec';
import FirstSetting from './../views/FirstSetting';
import FirstSettingExec from './../views/FirstSettingExec';
import Coupons from './../views/Coupons';
import CouponDetail from './../views/Coupons/Detail';

const routings = (
  <>
    <Route exact path="/login" component={Login} title={"ログイン"}/>
    <Route exact path="/" component={Member} title={"メンバートップ"}/>
    <Route exact path="/information_detail/:id" component={InformationDetail} title={"お知らせ詳細"}/>
    <Route exact path="/use_fastlane" component={UseFastlane} title={"ファストレーンを使用する"}/>
    <Route exact path="/permit_error" component={PermitError} title={"エラー"}/>
    <Route exact path="/display_permit" component={DisplayPermit} title={""}/>
    <Route exact path="/my_page" component={MyPage} title={""}/>
    <Route exact path="/password_reset" component={PasswordReset} title={""}/>
    <Route exact path="/password_reset_exec" component={PasswordResetExec} title={""}/>
    <Route exact path="/first_setting" component={FirstSetting} title={""}/>
    <Route exact path="/first_setting_exec" component={FirstSettingExec} title={""}/>
    <Route exact path="/coupons" component={Coupons} title={"クーポン"}/>
    <Route exact path="/coupons/detail/:id" component={CouponDetail} title={"クーポン詳細"}/>
    {/*<Route exact path="/" component={Companies} title={"マイページ"}/>*/}
    <Route component={Member}/>
  </>
);

const App = observer(() => {
  if (globalStore.hasServerError) {
    return (
      <Router>
        <div id="routerRoot">
          <ServerError />
        </div>
      </Router>
    );
  }

  return (
    <Router>
      <div id="routerRoot">
        <Switch>
          {routings.props.children}
        </Switch>
      </div>
    </Router>
  );
});
globalStore.routeMap = getRouteMap(routings);

export default App
